module.exports = __webpack_public_path__ + "img/ES.537b0028.png";